<script setup>
import IntegrityWarningPanel from './IntegrityWarningPanel.vue'

defineProps({
  warnings: {
    type: Array,
    default: () => [],
  },
})
</script>

<template>
  <section class="lottery-integrity-section">
    <IntegrityWarningPanel :warnings="warnings" title="Lottery Integrity Signals" />
  </section>
</template>

<style scoped>
.lottery-integrity-section { display: grid; gap: 0.6rem; }
</style>

